import { ReactElement } from "react"
import { WrapperProps } from "./wrapper-props"
import * as S from './wrapper-style'

export function Wrapper ({ children }: WrapperProps): ReactElement {
  return <S.Container>{children}</S.Container>
}